export const DIRECT_PAYMENT_RECEIVE = {
    BASE_PATH: '/direct-sale-order/payment-receive/',
    ADD_PATH() {
        return this.BASE_PATH + 'add';
    },
    LIST_PAGE_TITLE: 'Direct Sales Order Payment Receive List',
    EDIT_PAGE_TITLE: 'Edit Direct Sales Order Payment Receive',
    GET_ALL: 'direct-sale-order/payment-receive',
    GET_ONE: 'direct-sale-order/payment-receive/edit/',
    CREATE: 'direct-sale-order/payment-receive/create',
    UPDATE: 'direct-sale-order/payment-receive/update/',
    DELETE: 'direct-sale-order/payment-receive/delete/',
};
